import { Platform } from "react-native";

/** Whether the current platform is web. */
export const isWeb = Platform.OS === "web";
